import React from 'react';
import { style, theme, HEADER_HEIGHT, STATUSBAR_HEIGHT, IPHONEX_MARGIN } from 'constants';
import { View, Text } from 'react-native';
import { Link, isWeb, ActivityIndicator, Badge } from 'core';
import { IcoBack, IcoClose } from 'icons';
import * as actions from 'actions';
import { lang } from 'lang';
const styles = style({
  holder: {
    height: HEADER_HEIGHT,
    paddingTop: STATUSBAR_HEIGHT,
    alignItems: 'stretch',
    justifyContent: 'space-between',
    flexDirection: 'row',
    backgroundColor: theme.gray_color_lighten(0.01),
    borderColor: theme.gray_color_lighten(0.2),
    borderBottomWidth: theme.hairline
  },
  title_container: {
    paddingHorizontal: 10,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    flex: 1
  },
  title: {
    fontSize: 16
  },
  sub_title: {
    fontSize: 12,
    color: theme.gray_color_lighten(0.4)
  },
  edge: {
    minHeight: 44,
    minWidth: 44,
    justifyContent: 'center',
    padding: 10
  },
  connnecting: { marginHorizontal: 5, fontSize: theme.font_sm, color: theme.gray_color_lighten(0.5) }
});

export const AppHeaderComp = ({
  style,
  children,
  back,
  close,
  title,
  title_icon,
  title_press,
  sub_title,
  title_style,
  title_content_style,
  left,
  right,
  is_online,
  show_connecting,
  unread,
  show_unread,
  dispatch,
  ...props
}) => {
  const TitleComp = title_press ? Link : View;
  return (
    <View style={[styles.holder, style]} {...props}>
      {close ? (
        <Link
          keyboardDismiss
          style={styles.edge}
          icon={IcoClose}
          size={20}
          selected
          onPress={e => (typeof close === 'function' ? close(e) : actions.clickCloseModal())}
        />
      ) : null}
      {!isWeb && back ? (
        <Link keyboardDismiss style={styles.edge} icon={IcoBack} size={20} selected onPress={() => actions.clickBack(back)}>
          {show_unread ? <Badge title={unread} color={theme.primary_color} /> : null}
        </Link>
      ) : null}
      {left ? <View style={styles.edge}>{left}</View> : null}
      {children}
      <TitleComp onPress={title_press} style={[styles.title_container, { justifyContent: title_icon ? 'flex-start' : 'center' }]}>
        {title_icon ? title_icon : null}
        <View style={{ alignItems: title_icon ? 'flex-start' : 'center', paddingHorizontal: 10 }}>
          {title && (
            <Text ellipsizeMode={'tail'} numberOfLines={1} style={styles.title && title_style}>
              {title}
            </Text>
          )}
          {!is_online && show_connecting ? (
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <ActivityIndicator size={'small'} />
              <Text style={styles.connnecting}>{lang.CONNECTING}</Text>
            </View>
          ) : sub_title ? (
            <Text ellipsizeMode={'tail'} numberOfLines={1} style={styles.sub_title}>
              {sub_title}
            </Text>
          ) : null}
        </View>
      </TitleComp>
      {close || (!isWeb && back) || right ? <View style={styles.edge}>{right}</View> : null}
    </View>
  );
};



// WEBPACK FOOTER //
// ./src/components/core/header.js